/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-22 08:55:59
 * @LastEditors: may.li
 * @LastEditTime: 2023-09-12 11:13:23
 */
import Nofound from ".././components/page/Nofound.vue";
import Iframe from ".././components/page/Iframe.vue";
// 遇见平遥
import agentQrcodeDetail from "./../components/page/m/my/agent/qrcodelog.vue"; //  二级分销商已绑的码 扫码记录
import agentAllQrcodes from "./../components/page/m/my/agent/allQrcodes.vue"; // 二级分销商已绑的码列表
// 第三方商城
import thirdShopIndex from ".././components/page/m/thirdshop/index.vue"
import thirdShopGoods from ".././components/page/m/thirdshop/goods.vue"
import thirdShopSettle from ".././components/page/m/thirdshop/settle.vue"
// 积分记录
import userJifen from ".././components/page/m/my/jifen/jilu.vue"
// 数字藏品
import cangpinAccount from "@/views/shuzicangpin/account.vue";
import cangpinLogin from "@/views/shuzicangpin/login.vue";
// 非遗锦盒
import JinheIndex from ".././components/page/m/jinhe.vue";
// 业务员查看二级分销商所有二维码
import salesmanAgentAllma from ".././components/page/m/my/salesman/agentAllma.vue"
// 业务员的二级分销商 
import salesmanAgent from ".././components/page/m/my/salesman/agent.vue"
// 业务员的扫码记录页
import salesmanSaomalog from ".././components/page/m/my/salesman/saomalog.vue"
// 业务员的中心页
import salesmanIndex from ".././components/page/m/my/salesman/index.vue"
// 一级分销商下的业务员的扫码记录
import agentSalesmanSaomalog from ".././components/page/m/my/agent/salesmansaomalog.vue";
// 一级分销商下的业务员列表
import agentSalesman from ".././components/page/m/my/agent/salesman.vue";
// 商家中心 商品&定制推送
import tradesmanPush from ".././components/page/m/my/tradesman/push.vue";
// 分销商匠人 商品&定制推送
import agentTradesmanGoodsPush from ".././components/page/m/my/agent/tradesmanGoodsPush.vue";
// 分销商可发展匠人
import agentTradesmanAdd from ".././components/page/m/my/agent/tradesmanAdd.vue";
// 登录
import Login from ".././components/page/user/login.vue";
// 专题
import zhuantiDetail from ".././components/page/m/zhuanti/detail.vue"
// 首页
import Index from ".././components/page/m/index/index.vue"; // 首页
// 一级搜索页面
import searchIndex from ".././components/page/m/search/index.vue";
import searchNew from ".././components/page/m/search/search.vue";
import searchItem from ".././components/page/m/search/item.vue";

// 商城模块
import Shop from ".././components/page/m/shop/index.vue"; // 商城
import btobShop from ".././components/page/m/shop/btob.vue"; // BToB商城
import ShopDetail from ".././components/page/m/shop/detail.vue"; // 商品详情页
import ShopSettle from ".././components/page/m/shop/settle.vue"; // 商品结算页
import ShopPay from ".././components/page/m/shop/pay.vue"; // 商品支付页
import paySuccess from ".././components/page/m/shop/success.vue"; // 商品支付成功页
import shopCart from ".././components/page/m/shop/cart.vue"; // 购物车
import goodsComment from ".././components/page/m/shop/comment.vue"; // 全部评论
import shopOrder from ".././components/page/m/my/order/shop/index.vue"; // 商品订单列表
import orderDetail from ".././components/page/m/my/order/shop/detail.vue"; // 订单详情
import orderComment from ".././components/page/m/my/order/shop/comment.vue"; // 订单评论
import orderTuikuanIndex from ".././components/page/m/my/order/shop/tuikuan/index.vue"; // 申请退货
import orderTuikuanDetail from ".././components/page/m/my/order/shop/tuikuan/detail.vue"; // 退款详情
import goodsFenlei from ".././components/page/m/shop/fenlei.vue"; // 商品分类
import goodsList from ".././components/page/m/shop/goodsList.vue"; // 商品分类列表
import goodsSpecial from ".././components/page/m/shop/special.vue"; // 商品分类列表
import shopOrderSaled from ".././components/page/m/my/order/shop/afterSale.vue"; // 售后
import orderKuaizhao from ".././components/page/m/my/order/shop/kuaizhao.vue"; // 订单快照

// 地图
import MapIndex from ".././components/page/m/map/index/index.vue"; // 地图 周边非遗
import MapQgIndex from ".././components/page/m/map/quanguo/index.vue"; // 全国非遗
import ItemIndex from ".././components/page/m/map/item/index.vue"; // 非遗项目列表
import ItemDetail from ".././components/page/m/map/item/detail.vue"; // 非遗项目详情
import ItemBaocuo from ".././components/page/m/map/item/baocuo.vue"; // 非遗项目报错
import ItemComment from ".././components/page/m/map/item/comment.vue"; // 非遗项目评论
import mapAnywhere from ".././components/page/m/map/item/map.vue"; // 地图 具体某个点的高德地图

// 用户中心
import MyIndex from ".././components/page/m/my/index/index.vue"; // 用户中心
import userAdress from ".././components/page/m/my/adress/index.vue"; // 用户地址列表
import addAdress from ".././components/page/m/my/adress/add.vue"; // 用户地址添加
import userInvoice from ".././components/page/m/my/invoice/index.vue"; // 用户发票列表
import addInvoice from ".././components/page/m/my/invoice/add.vue"; // 用户发票添加
import couponIndex from ".././components/page/m/my/coupon/index.vue"; // 优惠券
import commentIndex from ".././components/page/m/my/comment/index.vue"; // 评论
import xiaofeiIndex from ".././components/page/m/my/xiaofei/index.vue"; // 消费记录
import collectIndex from ".././components/page/m/my/collection/index.vue"; // 我的收藏
import fansIndex from ".././components/page/m/my/fans/index.vue"; // 粉丝列表
import followIndex from ".././components/page/m/my/follow/index.vue"; // 关注列表
import zitiIndex from ".././components/page/m/my/ziti/index.vue"; // 我的自提
import partnerIndex from ".././components/page/m/my/partner/index.vue"; // 城市合伙人首页
import agentIndex from ".././components/page/m/my/agent/index.vue"; // 代理商首页
import agentMember from ".././components/page/m/my/agent/member.vue"; // 代理商会员
import agentTradesman from ".././components/page/m/my/agent/tradesman.vue"; // 代理商匠人
import agentQRCode from ".././components/page/m/my/agent/qrcode.vue"; // 代理商二维码
import incomeList from ".././components/page/m/my/agent/income.vue"; // 收入明细
import withdrawList from ".././components/page/m/my/agent/withdrawList.vue"; // 提现明细
import withdraw from ".././components/page/m/my/agent/withdraw.vue"; // 提现
import bankIndex from ".././components/page/m/my/bank/index.vue"; // 银行卡列表
import bankAdd from ".././components/page/m/my/bank/add.vue"; // 添加银行卡
import UserInfo from ".././components/page/m/my/index/info.vue"; // 设置
import Nickname from ".././components/page/m/my/index/nickname.vue"; // 修改昵称
import Password from ".././components/page/m/my/index/password.vue"; // 修改密码
import Phone from ".././components/page/m/my/index/phone.vue"; // 修改手机号
import ApplyTransition from ".././components/page/m/my/cooperation/transition.vue"; // 申请合作 中间页
import ApplyTradesman from ".././components/page/m/my/cooperation/tradesman.vue"; // 申请成为匠人
import ApplySeller from ".././components/page/m/my/cooperation/seller.vue"; // 申请成为供应商
import ApplyAgent from ".././components/page/m/my/cooperation/agent.vue"; // 申请成为代理商
import ApplyPartner from ".././components/page/m/my/cooperation/partner.vue"; // 申请成为城市合伙人
import tradesmanApplying from ".././components/page/m/my/cooperation/applying.vue"; // 申请成为匠人 个人/公司-- 审核中
import TradesmanIndex from ".././components/page/m/my/tradesman/index.vue"; // 匠人首页
import TradesmanOrder from ".././components/page/m/my/tradesman/order.vue"; // 匠人订单列表
import TradesmanOrderDetail from ".././components/page/m/my/tradesman/orderDetail.vue"; // 匠人订单详情
import TradesmanCenter from ".././components/page/m/my/tradesman/center.vue"; // 匠人账户中心
import TradesmanIncome from ".././components/page/m/my/tradesman/income.vue"; // 匠人收入明细
import TradesmanPhoto from ".././components/page/m/my/tradesman/photoList.vue"; // 匠人图集
import TradesmanPhotoAdd from ".././components/page/m/my/tradesman/photoAdd.vue"; // 匠人图集新增
import TradesmanGoods from ".././components/page/m/my/tradesman/goods.vue"; // 匠人商品管理
import TradesmanDingzhi from ".././components/page/m/my/tradesman/dingzhi.vue"; // 匠人定制管理
import TradesmanQRCode from ".././components/page/m/my/tradesman/qrcode.vue"; // 匠人二维码
import shopSet from ".././components/page/m/my/tradesman/shopset.vue"; // 匠人店铺设置
import kuaidiSet from ".././components/page/m/my/tradesman/kuaidiset.vue"; // 匠人店铺设置
import tradesmanPartner from ".././components/page/m/my/tradesman/partner.vue"; // 匠人的合作伙伴 代理商和合伙人
import TradesmanDingzhiSelf from ".././components/page/m/my/tradesman/dingzhifromtradesman.vue"; // 匠人定制管理,他自己发出的
import TradesmanDingzhiOrder from ".././components/page/m/my/tradesman/dingzhiOrder.vue"; // 匠人定制订单列表,他自己发出的
import TradesmanDingzhiOrderDetail from ".././components/page/m/my/tradesman/dingzhiOrderDetail.vue"; // 匠人定制订单详情,他自己发出的

// 供应商中心
import btobIndex from ".././components/page/m/my/btob/index.vue"; // 首页
import btobCenter from ".././components/page/m/my/btob/center.vue"; // 供应商中心
import sellerIncome from ".././components/page/m/my/btob/income.vue"; // 收入
import sellerGoods from ".././components/page/m/my/btob/goods.vue"; // 商品
import sellerShop from ".././components/page/m/my/btob/shopset.vue"; // 店铺设置
// 设置
import setIndex from ".././components/page/m/my/setting/index.vue"; // 设置中心首页
import setAccount from ".././components/page/m/my/setting/account.vue"; // 设置账户中心
import setStaff from ".././components/page/m/my/setting/staff.vue"; // 设置 员工认定
import setChargeCard from ".././components/page/m/my/setting/chargeCard.vue"; // 设置 充值卡
import setBindCard from ".././components/page/m/my/setting/bindCard.vue"; // 设置 绑定充值卡
import setCardRecord from ".././components/page/m/my/setting/cardRecord.vue"; // 设置 充值卡使用记录
import bindPhone from ".././components/page/m/my/setting/bindPhone.vue"; // 设置 绑定手机号
import setNickname from ".././components/page/m/my/setting/nickname.vue"; // 设置 昵称
import setPhone from ".././components/page/m/my/setting/phone.vue"; // 设置 手机号
import setHelp from ".././components/page/m/my/setting/help.vue"; // 设置 帮助中心
import setFeedback from ".././components/page/m/my/setting/feedback.vue"; // 设置 意见反馈
import setZhuxiao from ".././components/page/m/my/setting/zhuxiao.vue"; // 永久注销账号
import setZhuxiao2 from ".././components/page/m/my/setting/zhuxiao2.vue"; // 永久注销账号

// 约看
import yuankanOrderIndex from ".././components/page/m/yuekan/order/index.vue"; // 约看订单
import yuekanIndex from ".././components/page/m/yuekan/index.vue"; // 约看首页
import yuekanDetail from ".././components/page/m/yuekan/detail.vue"; // 约看详情
import yuekanBook from ".././components/page/m/yuekan/book.vue"; // 约看预约
import yuekanPay from ".././components/page/m/yuekan/pay.vue"; // 约看支付

// 匠人
import ArtIndex from ".././components/page/m/artisan/index.vue"; // 匠人首页
import ArtDetail from ".././components/page/m/artisan/detail.vue"; // 匠人详情页
import ArtInfo from ".././components/page/m/artisan/info.vue"; // 匠人介绍页
import ArtOtherDetail from ".././components/page/m/artisan/odetail.vue"; // 匠人详情页
import ArtPhoto from ".././components/page/m/artisan/photo.vue"; // 匠人图集页
import ArtDingzhi from ".././components/page/m/artisan/dingzhi.vue"; // 匠人定制页
import ArtHead from ".././components/page/m/artisan/head.vue"; // 匠人头条页

// 消息
import MessageIndex from ".././components/page/m/message/index.vue"; // 消息首页
import SystemMessage from ".././components/page/m/message/systemList.vue"; // 系统消息列表 && 站内消息详情
import SystemMessageInfo from ".././components/page/m/message/systemInfo.vue"; // 系统消息详情 && 站内消息详情
import OrderMessage from ".././components/page/m/message/orderList.vue"; // 订单消息列表
import tradesmanChat from ".././components/page/m/message/tradesmanChat.vue"; // 与匠人聊天
import kefuChat from ".././components/page/m/message/kefuChat.vue"; // 与匠人聊天

// 我的视频
import videoIndex from ".././components/page/m/my/video/index.vue"; // 我的视频
import videoLog from ".././components/page/m/my/video/videolog.vue"; // 我的视频

// 单页
import singlePage from ".././components/page/m/singlepage/index.vue"; // 单页

// 系统开发中
import developing from ".././components/page/m/developing/index.vue"; // 系统开发中

// 直播
import zhiboIndex from ".././components/page/m/zhibo/index.vue"; // 直播首页
import zhiboDetail from ".././components/page/m/zhibo/detail.vue"; // 直播详情
import zhiboApply from ".././components/page/m/zhibo/apply.vue"; // 直播申请
import zhiboApplying from ".././components/page/m/zhibo/applying.vue"; // 直播详情中
// 视频-查看更多
import videoList from ".././components/page/m/zhibo/videolist.vue"; // 视频&直播列表
// 视频-详情
import videoDetail from ".././components/page/m/zhibo/videodetail.vue"; // 视频详情
// 视频-播放
import videoPlay from ".././components/page/m/zhibo/videoplay.vue"; // 视频播放
// 直播视频回放
import posvideoDetail from "../components/page/m/zhibo/posvideoplay.vue"; // 直播视频回放
// 视频-播放
import posvideoPlay from ".././components/page/m/zhibo/posvideoplay.vue"; // 视频播放
import videoPay from ".././components/page/m/zhibo/pay.vue"; // 视频-购买 弃用,同约看支付是一个页面
import videoComment from ".././components/page/m/zhibo/comment.vue"; // 视频评论

// uuid
import uuidIndex from ".././components/page/m/uuidpage/index.vue";
// 供应商详情 -- 与匠人详情分开
import sellerDetail from ".././components/page/m/seller/detail.vue"; // 首页

// 园区
import parkIndex from ".././components/page/m/park/index.vue"; // 首页
import parkJifen from ".././components/page/m/park/jifenList.vue"; // 积分列表
import parkRank from ".././components/page/m/park/rankRule.vue"; // 积分列表

// 头条
import toutiaoIndex from ".././components/page/m/toutiao/index.vue"; // 首页
import toutiaoDetail from ".././components/page/m/toutiao/detail.vue"; // 详情
import toutiaoPublish from ".././components/page/m/toutiao/publish.vue"; // 发布
import toutiaoSheQu from ".././components/page/m/toutiao/shequ.vue"; // 社区

// 历史上的今天
import tohistoryIndex from ".././components/page/m/tohistory/index.vue"; // 首页
import tohistoryDetail from ".././components/page/m/tohistory/detail.vue"; // 详情
import adriftList from ".././components/page/m/tohistory/adriftList.vue"; // 漂流列表
import adriftDetail from ".././components/page/m/tohistory/adriftDetail.vue"; // 漂流列表
import adriftPublish from ".././components/page/m/tohistory/adriftPublish.vue"; // 漂流发布
import myAdriftIndex from ".././components/page/m/my/piaoliu/index.vue"; // 我的漂流
import locationList from ".././components/page/m/tohistory/locationList.vue"; // 获取位置

// 定制
import dingzhiIndex from ".././components/page/m/dingzhi/index.vue"; // 首页
import dingzhiDetail from ".././components/page/m/dingzhi/detail.vue"; // 详情-商家发的
import dingzhiSettle from ".././components/page/m/dingzhi/settle.vue"; // 结算
import orderDingzhiIndex from ".././components/page/m/my/dingzhi/orderIndex.vue"; // 订单列表
import orderDingzhiDetail from ".././components/page/m/my/dingzhi/orderDetail.vue"; // 订单详情
import orderDingzhiBid from ".././components/page/m/my/dingzhi/orderBid.vue"; // 订单 招标中
import dingzhiSheQu from ".././components/page/m/dingzhi/shequ.vue"; // 社区
import dingzhiForm from ".././components/page/m/dingzhi/dingzhiForm.vue"; // 我要定制
import dingzhiFormDetail from ".././components/page/m/dingzhi/dingzhiFormDetail.vue"; // 我要定制详情
import dingzhiPublish from ".././components/page/m/dingzhi/publish.vue"; // 发布定制
import dingzhiTradesman from ".././components/page/m/dingzhi/tradesmanList.vue"; // 定制匠人
import dingzhiTradesmanWorks from ".././components/page/m/dingzhi/tradesmanWorks.vue"; // 定制匠人作品
import dingzhiDetailUser from ".././components/page/m/dingzhi/detailUser.vue"; // 详情-用户发的
import myDingzhiIndex from ".././components/page/m/my/dingzhi/myDingzhi.vue"; // 订单列表
import dingzhiComment from ".././components/page/m/my/dingzhi/orderComment.vue"; // 定制订单评价
import tradesmanToUserForm from ".././components/page/m/dingzhi/tradesmantouserform.vue"; // 定制单,匠人主动发给用户的
import orderDingzhiKuaizhao from ".././components/page/m/my/dingzhi/orderKuaizhao.vue"; // 定制单快照
import dingzhiZhuanshujia from ".././components/page/m/my/tradesman/dingzhiZhuanshujia.vue"; // 匠人设置 定制专属价

// 一级代理商
import mySecondAgent from ".././components/page/m/my/agent/secondAgent.vue"; // 一级下面的二级代理商

// 园区中心
import myParkIndex from ".././components/page/m/my/park/index.vue"; // 首页
import myParkWithdraw from ".././components/page/m/my/park/withdraw.vue"; // 提现
import myParkIncome from ".././components/page/m/my/park/income.vue"; // 收入明细
import myParkOrder from ".././components/page/m/my/park/order.vue"; // 订单列表
import myParkOrderDetail from ".././components/page/m/my/park/orderDetail.vue"; // 订单详情
import myParkTradesmanList from ".././components/page/m/my/park/tradesmanList.vue"; // 匠人列表
import myParkAgent from ".././components/page/m/my/park/agentList.vue"; // 一级分销商
import myParkSecAgent from ".././components/page/m/my/park/secAgentList.vue"; // 二级分销商

// 原来的支付 https://mall.shidaijiyi.com/reapal/index
import reapalIndex from ".././components/page/m/reapal/index.vue";
import payIndex from ".././components/page/m/pay/index.vue"; // 公共的支付页,融宝白名单支持

// 园区商城
import parkmallList from ".././components/page/m/parkmall/list.vue"; // 列表页
import parkmallIndex from ".././components/page/m/parkmall/index.vue"; // 首页
import parkmallGoodsList from ".././components/page/m/parkmall/goodsList.vue"; // 商品列表

// 区块链商城
import chainIndex from ".././components/page/m/blockchain/index.vue"; // 商城
import chainTraceCode from ".././components/page/m/blockchain/tracecode.vue"; // 追溯码查询
import chainScanCode from ".././components/page/m/blockchain/scancode.vue"; // 扫二维码查询
import chainScanCodeDetail from ".././components/page/m/blockchain/scancodedetail.vue"; // 二维码详情
import chainScanCodeRecord from ".././components/page/m/blockchain/scanrecord.vue"; // 二维码详情
// 智慧园区
import smartParkIndex from ".././components/page/m/smartpark/index.vue"; // 首页
import smartParkShopList from ".././components/page/m/smartpark/shopList.vue"; // 馆列表
import smartParkAppoint from ".././components/page/m/smartpark/appointshop.vue"; // 预约馆
import smartParkAppointTicket from ".././components/page/m/smartpark/appointticket.vue"; // 预约票
import smartParkTuanti from ".././components/page/m/smartpark/tuantiform.vue"; // 团体票表单
import smartParkAddvisitor from ".././components/page/m/smartpark/addvisitor.vue"; // 添加参观者
import smartParkPersonal from ".././components/page/m/smartpark/personalform.vue"; // 个人票表单
import smartParkHexiao from ".././components/page/m/smartpark/hexiao.vue"; // 核销票
import visitorList from ".././components/page/m/smartpark/visitorlist.vue"; // 参观者列表
import smartparkPay from ".././components/page/m/smartpark/pay.vue"; // 支付页面
import smartparkPaysuccess from ".././components/page/m/smartpark/paysuccess.vue"; // 支付成功页
import smartParkOrderList from ".././components/page/m/smartpark/order/list.vue"; // 订单列表
import smartParkOrderDetail from ".././components/page/m/smartpark/order/detail.vue"; // 订单详情
import smartParkOrderApply from ".././components/page/m/smartpark/order/apply.vue"; // 申请发票
import smartParkCardList from ".././components/page/m/smartpark/cardlist.vue"; // 次卡列表
import mySmartparkCard from ".././components/page/m/smartpark/card/list.vue"; // 我的次卡
import mySmartparkCardDetail from ".././components/page/m/smartpark/card/detail.vue"; // 我的次卡详情
// 献礼
import xianliIndex from ".././components/page/m/xianli/index.vue"; // 首页
import xianliPublish from ".././components/page/m/xianli/publish.vue"; // 发布
import xianliDetail from ".././components/page/m/xianli/detail.vue"; // 详情
// 足迹
import zujiIndex from ".././components/page/m/my/zuji/index.vue"
// 举报 安卓APP需要
import setJubao from ".././components/page/m/jubao.vue"
// 约看订单详情
import yuankanOrderDetail from ".././components/page/m/yuekan/order/detail.vue"
// 全球地图
import MapQqIndex from ".././components/page/m/map/quanqiu/index.vue"

export default [
	{
		// 第三方商城 结算
		path: "/third/settle",
		name: "third-settle",
		component: thirdShopSettle,
		meta: {
			requiresAuth: true,
			title: "结算",
			keepAlive: false,
			share_config: false
		}
	},
	{
		// 第三方商城 商品详情
		path: "/third/goods",
		name: "third-goods",
		component: thirdShopGoods,
		meta: {
			requiresAuth: false,
			title: "商城",
			keepAlive: false,
			share_config: false
		}
	},
	{
		// 第三方商城 
		path: "/third/shop",
		name: "third-shop",
		component: thirdShopIndex,
		meta: {
			requiresAuth: false,
			title: "商城",
			keepAlive: false,
			share_config: false
		}
	},
	{
		// 数字藏品 用户页 
		path: "/cangpin/account",
        name: "cangpin-account",
        component: cangpinAccount,
        meta: {
            requiresAuth: true,
            title: "数字藏品",
            keepAlive: false,
            share_config: false,
        },
	},
	{
		// 数字藏品 登录页
		path: "/cangpin/login",
        name: "cangpin-login",
        component: cangpinLogin,
        meta: {
            requiresAuth: false,
            title: "数字藏品",
            keepAlive: false,
            share_config: false,
        },
	},
    {
        // 登录页
        path: "/login", // 非嵌套路由加 /
        name: "login",
        component: Login,
        meta: {
            requiresAuth: false,
            title: "登录",
            keepAlive: false,
            share_config: true,
        },
    },
    // 内容的模板
    {
        path: "/",
        component: Iframe,
        meta: {
            requiresAuth: false,
        },
        children: [
			// 全球地图
            {
                path: "quanqiu/index",
                name: "map-quanqiu",
                component: MapQqIndex,
                meta: {
                    requiresAuth: false,
                    title: "非遗地图",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    app_icon_back: true,
                    share_config: true,
                },
            },
			// 二级分销商 已绑的码详情
			{
                path: "agent/qrcode/detail",
                name: "agent-qrcode-detail",
                component: agentQrcodeDetail,
                meta: {
                    requiresAuth: true,
                    title: "分销商二维码详情",
					keepAlive: false,
					icon_back: false,
					share_config: true
                },
            },
			// 二级分销商 已绑的所有码
			{
                path: "agent/allqrcodes",
                name: "agent-allqrcodes",
                component: agentAllQrcodes,
                meta: {
                    requiresAuth: true,
                    title: "分销商二维码",
                    keepAlive: false,
					icon_back: false,
					share_config: true
                },
            },
			// 积分记录
			{
				path: "my/jifen",
				name: "my-jifen",
				component: userJifen,
				meta: {
					requiresAuth: true,
					title: "积分记录",
					keepAlive: false,
					icon_back: false,
					share_config: true
				},
			},
			{
				// 非遗锦盒
				path: "/jinhe",
				name: "jinhe-index",
				component: JinheIndex,
				meta: {
					requiresAuth: false,
					title: "非遗锦盒",
					keepAlive: false,
					icon_back: false,
					share_config: true
				},
			},
			// 业务员的二级分销商的所有码
			{
                path: "salesman/agent/allma",
                name: "salesman-agent-allma",
                component: salesmanAgentAllma,
                meta: {
                    requiresAuth: true,
                    title: "分销商二维码",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 业务员 一级分销商下的二级分销商
			{
                path: "salesman/agent",
                name: "salesman-agent",
                component: salesmanAgent,
                meta: {
                    requiresAuth: true,
                    title: "业务员的二级分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 业务员扫码记录
			{
                path: "salesman/saomalog",
                name: "salesman-saomalog",
                component: salesmanSaomalog,
                meta: {
                    requiresAuth: true,
                    title: "业务员扫码记录",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 业务员中心
			{
                path: "salesman/index",
                name: "salesman-index",
                component: salesmanIndex,
                meta: {
                    requiresAuth: true,
                    title: "业务员",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 一级分销商下的业务员的扫码记录
			{
                path: "agent/salesman/saomalog",
                name: "agent-salesman-saomalog",
                component: agentSalesmanSaomalog,
                meta: {
                    requiresAuth: true,
                    title: "扫码记录",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 一级分销商下的业务员列表 
			{
                path: "agent/salesman",
                name: "agent-salesman",
                component: agentSalesman,
                meta: {
                    requiresAuth: true,
                    title: "业务员",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 商家中心 商品或定制推送 
			{
                path: "tradesman/push",
                name: "tradesman-push",
                component: tradesmanPush,
                meta: {
                    requiresAuth: true,
                    title: "推送",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 二级分销商 匠人商品或定制推送到小程序 
			{
                path: "agent/tradesman/push",
                name: "agent-tradesman-push",
                component: agentTradesmanGoodsPush,
                meta: {
                    requiresAuth: true,
                    title: "推送",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 二级分销商可发展匠人
			{
                path: "agent/tradesman/add",
                name: "agent-tradesman-add",
                component: agentTradesmanAdd,
                meta: {
                    requiresAuth: true,
                    title: "添加匠人",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 首页
            {
                path: "/",
                name: "home",
                component: Index,
                meta: {
                    requiresAuth: false,
                    title: "时代记忆",
                    role: 0,
                    keepAlive: true,
                    bottom_tab: true, // 用于判断页面是否显示底部tab
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    share_config: true, // 分享配置,false在页面里单独配置,true在iframe模板里统一配置
                },
            },
            // 举报
			{
				path: "set/jubao",
                name: "set-jubao",
                component: setJubao,
                meta: {
                    requiresAuth: true,
                    title: "举报",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
			},
			// 专题
			{
				path: "zhuanti/detail",
                name: "zhuanti-detail",
                component: zhuantiDetail,
                meta: {
                    requiresAuth: false,
                    title: "专题",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
			},
            // 商城 b2c
            {
                path: "shop/index",
                name: "shop",
                component: Shop,
                meta: {
                    requiresAuth: false,
                    title: "商城",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商城 b2b
            {
                path: "shop/btob",
                name: "shop-btob",
                component: btobShop,
                meta: {
                    requiresAuth: false,
                    title: "商城",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 我的
            {
                path: "my/index",
                name: "my",
                component: MyIndex,
                meta: {
                    requiresAuth: false,
                    title: "我的",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 消息
            {
                path: "message/index",
                name: "message",
                component: MessageIndex,
                meta: {
                    requiresAuth: false,
                    title: "消息",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 系统消息列表
            {
                path: "message/system",
                name: "message-system",
                component: SystemMessage,
                meta: {
                    requiresAuth: false,
                    title: "消息列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 系统消息详情
            {
                path: "message/system/info",
                name: "message-system-info",
                component: SystemMessageInfo,
                meta: {
                    requiresAuth: false,
                    title: "消息详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 订单消息
            {
                path: "message/order",
                name: "message-order",
                component: OrderMessage,
                meta: {
                    requiresAuth: true,
                    title: "订单信息",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 与匠人聊天消息
            {
                path: "tradesman/chat",
                name: "tradesman-chat",
                component: tradesmanChat,
                meta: {
                    requiresAuth: false,
                    title: "消息",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 与客服聊天消息
            {
                path: "kefu/chat",
                name: "kefu-chat",
                component: kefuChat,
                meta: {
                    requiresAuth: false,
                    title: "消息",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 地图
            {
                path: "map/index",
                name: "map",
                component: MapIndex,
                meta: {
                    requiresAuth: false,
                    title: "非遗地图",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 全国地图
            {
                path: "quanguo/index",
                name: "map-quanguo",
                component: MapQgIndex,
                meta: {
                    requiresAuth: false,
                    title: "非遗地图",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    app_icon_back: true,
                    share_config: true,
                },
            },
            // 非遗项目 列表
            {
                path: "item/index",
                name: "map-item",
                component: ItemIndex,
                meta: {
                    requiresAuth: false,
                    title: "项目列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 非遗项目 详情
            {
                path: "item/detail",
                name: "map-itemdetail",
                component: ItemDetail,
                meta: {
                    requiresAuth: false,
                    title: "项目详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            //  匠人列表
            {
                path: "art/index",
                name: "art-index",
                component: ArtIndex,
                meta: {
                    requiresAuth: false,
                    title: "匠人",
                    role: 0,
                    keepAlive: true,
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    share_config: true,
                },
            },
            //  匠人详情
            {
                path: "art/detail",
                name: "art-detail",
                component: ArtDetail,
                meta: {
                    requiresAuth: false,
                    title: "匠人详情",
                    role: 0,
                    keepAlive: true,
                    icon_back: true, // 用于判断页面是否显示返回按钮
                    app_icon_back: true,
                    share_config: false,
                },
            },
            //  匠人详情
            {
                path: "art/odetail",
                name: "art-odetail",
                component: ArtOtherDetail,
                meta: {
                    requiresAuth: false,
                    title: "匠人详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true, // 用于判断页面是否显示返回按钮
                    app_icon_back: true,
                    share_config: false,
                },
            },
            //  匠人定制
            {
                path: "art/dingzhi",
                name: "art-dingzhi",
                component: ArtDingzhi,
                meta: {
                    requiresAuth: false,
                    title: "匠人定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    app_icon_back: true,
                    share_config: false,
                },
            },
            //  匠人头条
            {
                path: "art/head",
                name: "art-head",
                component: ArtHead,
                meta: {
                    requiresAuth: false,
                    title: "匠人头条",
                    role: 0,
                    keepAlive: false,
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    app_icon_back: true,
                    share_config: false,
                },
            },
            //  匠人图集
            {
                path: "art/photo",
                name: "art-photo",
                component: ArtPhoto,
                meta: {
                    requiresAuth: false,
                    title: "图集",
                    role: 0,
                    keepAlive: false,
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    app_icon_back: true,
                    share_config: false,
                },
            },
            //  匠人介绍
            {
                path: "art/info",
                name: "art-info",
                component: ArtInfo,
                meta: {
                    requiresAuth: false,
                    title: "匠人介绍",
                    role: 0,
                    keepAlive: false,
                    icon_back: false, // 用于判断页面是否显示返回按钮
                    share_config: false,
                },
            },
            // 商品详情页
            {
                path: "shop/detail",
                name: "shop-detail",
                component: ShopDetail,
                meta: {
                    requiresAuth: false,
                    title: "商品详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 结算页面
            {
                path: "shop/settle",
                name: "shop-settle",
                component: ShopSettle,
                meta: {
                    requiresAuth: true,
                    title: "结算页面",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 支付页面
            {
                path: "shop/pay",
                name: "shop-pay",
                component: ShopPay,
                meta: {
                    requiresAuth: true,
                    title: "支付页面",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 支付成功页面
            {
                path: "pay/success",
                name: "pay-success",
                component: paySuccess,
                meta: {
                    requiresAuth: true,
                    title: "支付页面",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 用户地址列表
            {
                path: "user/adress",
                name: "user-adress",
                component: userAdress,
                meta: {
                    requiresAuth: true,
                    title: "收货地址",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 新增用户地址列表
            {
                path: "user/adressAdd",
                name: "add-adress",
                component: addAdress,
                meta: {
                    requiresAuth: true,
                    title: "新建收货地址",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 用户发票列表
            {
                path: "user/invoice",
                name: "user-invoice",
                component: userInvoice,
                meta: {
                    requiresAuth: true,
                    title: "发票",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 新增用户发票
            {
                path: "user/invoiceAdd",
                name: "add-invoice",
                component: addInvoice,
                meta: {
                    requiresAuth: true,
                    title: "新建发票",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 购物车
            {
                path: "shop/cart",
                name: "shop-cart",
                component: shopCart,
                meta: {
                    requiresAuth: true,
                    title: "购物车",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商品评论
            {
                path: "shop/comment",
                name: "shop-comment",
                component: goodsComment,
                meta: {
                    requiresAuth: false,
                    title: "商品评论",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商城订单
            {
                path: "shop/order",
                name: "shop-order",
                component: shopOrder,
                meta: {
                    requiresAuth: true,
                    title: "商品订单列表",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
					isrefer: true // 是否要刷新
                },
            },
            // 售后
            {
                path: "shop/order/saled",
                name: "shop-order-saled",
                component: shopOrderSaled,
                meta: {
                    requiresAuth: true,
                    title: "售后",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 优惠券
            {
                path: "coupon/index",
                name: "coupon-index",
                component: couponIndex,
                meta: {
                    requiresAuth: true,
                    title: "优惠券",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 评论
            {
                path: "comment/index",
                name: "comment-index",
                component: commentIndex,
                meta: {
                    requiresAuth: true,
                    title: "我的评论",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 消费记录
            {
                path: "xiaofei/index",
                name: "xiaofei-index",
                component: xiaofeiIndex,
                meta: {
                    requiresAuth: true,
                    title: "消费记录",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 我的视频
            {
                path: "video/index",
                name: "video-index",
                component: videoIndex,
                meta: {
                    requiresAuth: true,
                    title: "我的视频",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 我的收藏
            {
                path: "collect/index",
                name: "collect-index",
                component: collectIndex,
                meta: {
                    requiresAuth: true,
                    title: "我的收藏",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 粉丝列表
            {
                path: "fans/index",
                name: "fans-index",
                component: fansIndex,
                meta: {
                    requiresAuth: true,
                    title: "粉丝列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 关注列表
            {
                path: "follow/index",
                name: "follow-index",
                component: followIndex,
                meta: {
                    requiresAuth: true,
                    title: "关注列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 自提订单
            {
                path: "ziti/index",
                name: "ziti-index",
                component: zitiIndex,
                meta: {
                    requiresAuth: true,
                    title: "我的自提",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 城市合伙人首页
            {
                path: "partner/index",
                name: "partner-index",
                component: partnerIndex,
                meta: {
                    requiresAuth: true,
                    title: "城市合伙人",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 代理商首页
            {
                path: "agent/index",
                name: "agent-index",
                component: agentIndex,
                meta: {
                    requiresAuth: true,
                    title: "分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 代理商会员
            {
                path: "agent/member",
                name: "agent-member",
                component: agentMember,
                meta: {
                    requiresAuth: true,
                    title: "分销商会员",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 代理商匠人
            {
                path: "agent/tradesman",
                name: "agent-tradesman",
                component: agentTradesman,
                meta: {
                    requiresAuth: true,
                    title: "代理商匠人",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 代理商二维码
            {
                path: "agent/qrcode",
                name: "agent-qrcode",
                component: agentQRCode,
                meta: {
                    requiresAuth: true,
                    title: "分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 收入明细
            {
                path: "agent/income",
                name: "agent-income",
                component: incomeList,
                meta: {
                    requiresAuth: true,
                    title: "收入明细",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 提现明细
            {
                path: "agent/withdrawList",
                name: "agent-withdrawList",
                component: withdrawList,
                meta: {
                    requiresAuth: true,
                    title: "提现明细",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 提现明细
            {
                path: "agent/withdraw",
                name: "agent-withdraw",
                component: withdraw,
                meta: {
                    requiresAuth: true,
                    title: "提现",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 银行卡列表
            {
                path: "bank/index",
                name: "bank-index",
                component: bankIndex,
                meta: {
                    requiresAuth: true,
                    title: "银行卡列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 添加/编辑/详情
            {
                path: "bank/add",
                name: "bank-add",
                component: bankAdd,
                meta: {
                    requiresAuth: true,
                    title: "添加银行卡",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 个人信息
            {
                path: "user/info",
                name: "user-info",
                component: UserInfo,
                meta: {
                    requiresAuth: true,
                    title: "个人信息",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 修改昵称
            {
                path: "user/nickname",
                name: "user-nickname",
                component: Nickname,
                meta: {
                    requiresAuth: true,
                    title: "修改昵称",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 修改手机号
            {
                path: "user/phone",
                name: "user-phone",
                component: Phone,
                meta: {
                    requiresAuth: true,
                    title: "修改手机号",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 申请合作
            {
                path: "cooperation/transition",
                name: "cooperation-transition",
                component: ApplyTransition,
                meta: {
                    requiresAuth: true,
                    title: "申请合作",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 申请成为匠人
            {
                path: "cooperation/tradesman",
                name: "cooperation-tradesman",
                component: ApplyTradesman,
                meta: {
                    requiresAuth: true,
                    title: "申请成为匠人",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 申请成为供应商
            {
                path: "cooperation/seller",
                name: "cooperation-seller",
                component: ApplySeller,
                meta: {
                    requiresAuth: true,
                    title: "申请成为供应商",
                    role: 0,
                    keepAlive: true,
                    share_config: true,
                },
            },
            // 申请成为代理商
            {
                path: "cooperation/agent",
                name: "cooperation-agent",
                component: ApplyAgent,
                meta: {
                    requiresAuth: true,
                    title: "申请成为分销商",
                    role: 0,
                    keepAlive: true,
                    share_config: true,
                },
            },
            // 申请成为城市合伙人
            {
                path: "cooperation/partner",
                name: "cooperation-partner",
                component: ApplyPartner,
                meta: {
                    requiresAuth: true,
                    title: "申请成为城市合伙人",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 匠人入驻 审核结果
            {
                path: "cooperation/applying",
                name: "cooperation-applying",
                component: tradesmanApplying,
                meta: {
                    requiresAuth: true,
                    title: "申请合作",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 店铺中心
            {
                path: "tradesman/index",
                name: "tradesman-index",
                component: TradesmanIndex,
                meta: {
                    requiresAuth: true,
                    title: "商家中心",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            //匠人订单列表
            {
                path: "tradesman/order",
                name: "tradesman-order",
                component: TradesmanOrder,
                meta: {
                    requiresAuth: true,
                    title: "订单列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人订单详情
            {
                path: "tradesman/orderDetail",
                name: "tradesman-orderDetail",
                component: TradesmanOrderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人账户中心
            {
                path: "tradesman/center",
                name: "tradesman-center",
                component: TradesmanCenter,
                meta: {
                    requiresAuth: true,
                    title: "账户中心",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人收入明细
            {
                path: "tradesman/income",
                name: "tradesman-income",
                component: TradesmanIncome,
                meta: {
                    requiresAuth: true,
                    title: "收入明细",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人图集
            {
                path: "tradesman/photo",
                name: "tradesman-photo",
                component: TradesmanPhoto,
                meta: {
                    requiresAuth: true,
                    title: "图集",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            //匠人图集新增编辑
            {
                path: "tradesman/photoadd",
                name: "tradesman-photoadd",
                component: TradesmanPhotoAdd,
                meta: {
                    requiresAuth: true,
                    title: "图集",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            //匠人商品管理
            {
                path: "tradesman/goods",
                name: "tradesman-goods",
                component: TradesmanGoods,
                meta: {
                    requiresAuth: true,
                    title: "商品管理",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人定制管理
            {
                path: "tradesman/dingzhi",
                name: "tradesman-dingzhi",
                component: TradesmanDingzhi,
                meta: {
                    requiresAuth: true,
                    title: "我承接的定制", // 定制管理
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            //匠人定制管理
            {
                path: "tradesman/dingzhi/self",
                name: "tradesman-dingzhi-self",
                component: TradesmanDingzhiSelf,
                meta: {
                    requiresAuth: true,
                    title: "我发布的定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 匠人二维码
            {
                path: "tradesman/qrcode",
                name: "tradesman-qrcode",
                component: TradesmanQRCode,
                meta: {
                    requiresAuth: true,
                    title: "商家二维码",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 修改密码
            {
                path: "user/password",
                name: "user-password",
                component: Password,
                meta: {
                    requiresAuth: true,
                    title: "修改密码",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 商品订单详情
            {
                path: "order/detail",
                name: "order-detail",
                component: orderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
			// 商品订单快照
            {
                path: "order/kuaizhao",
                name: "order-kuaizhao",
                component: orderKuaizhao,
                meta: {
                    requiresAuth: true,
                    title: "订单快照",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商品评价
            {
                path: "order/comment",
                name: "order-comment",
                component: orderComment,
                meta: {
                    requiresAuth: true,
                    title: "商品评价",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商品退换
            {
                path: "order/tuikuan/index",
                name: "order-tuikuan-index",
                component: orderTuikuanIndex,
                meta: {
                    requiresAuth: false,
                    title: "申请退换",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商品退换详情
            {
                path: "order/tuikuan/detail",
                name: "order-tuikuan-detail",
                component: orderTuikuanDetail,
                meta: {
                    requiresAuth: true,
                    title: "退款详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 约看
            {
                path: "yuekan/index",
                name: "yuekan-index",
                component: yuekanIndex,
                meta: {
                    requiresAuth: false,
                    title: "约看",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 约看详情
            {
                path: "yuekan/detail",
                name: "yuekan-detail",
                component: yuekanDetail,
                meta: {
                    requiresAuth: false,
                    title: "约看详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 约看订单列表
            {
                path: "yuekan/order/index",
                name: "yuekan-order-index",
                component: yuankanOrderIndex,
                meta: {
                    requiresAuth: true,
                    title: "约看订单",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 项目报错
            {
                path: "item/baocuo",
                name: "item-baocuo",
                component: ItemBaocuo,
                meta: {
                    requiresAuth: true,
                    title: "报错",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 项目评论
            {
                path: "item/comment",
                name: "item-comment",
                component: ItemComment,
                meta: {
                    requiresAuth: true,
                    title: "发表评论",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 门票预订
            {
                path: "yuekan/book",
                name: "yuekan-book",
                component: yuekanBook,
                meta: {
                    requiresAuth: true,
                    title: "门票预订",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 约看支付
            {
                path: "yuekan/pay",
                name: "yuekan-pay",
                component: yuekanPay,
                meta: {
                    requiresAuth: true,
                    title: "约看支付",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 地图 按地址搜索
            {
                path: "map/anywhere",
                name: "map-anywhere",
                component: mapAnywhere,
                meta: {
                    requiresAuth: false,
                    title: "地图",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 搜索页面
            {
                path: "search/index",
                name: "search",
                component: searchIndex,
                meta: {
                    requiresAuth: false,
                    title: "搜索",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 搜索页面
            {
                path: "search/search",
                name: "searchNew",
                component: searchNew,
                meta: {
                    requiresAuth: false,
                    title: "搜索",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                    bottom_tab: false,
                },
            },
            // 搜索项目页面
            {
                path: "search/item",
                name: "search-item",
                component: searchItem,
                meta: {
                    requiresAuth: false,
                    title: "搜索",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                    bottom_tab: false,
                },
            },
            // 商品分类
            {
                path: "goods/fenlei",
                name: "goods-fenlei",
                component: goodsFenlei,
                meta: {
                    requiresAuth: false,
                    title: "商品分类",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商品列表
            {
                path: "goods/list",
                name: "goods-list",
                component: goodsList,
                meta: {
                    requiresAuth: false,
                    title: "商品列表",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 专题
            {
                path: "goods/special",
                name: "goods-special",
                component: goodsSpecial,
                meta: {
                    requiresAuth: false,
                    title: "商品专题",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                },
            },
            // 设置 首页
            {
                path: "set/index",
                name: "set-index",
                component: setIndex,
                meta: {
                    requiresAuth: true,
                    title: "设置",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 账户信息
            {
                path: "set/account",
                name: "set-account",
                component: setAccount,
                meta: {
                    requiresAuth: true,
                    title: "账户信息",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 员工认定
            {
                path: "set/staff",
                name: "set-staff",
                component: setStaff,
                meta: {
                    requiresAuth: true,
                    title: "员工认定",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 充值卡
            {
                path: "set/card",
                name: "set-card",
                component: setChargeCard,
                meta: {
                    requiresAuth: true,
                    title: "充值卡",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 充值卡 绑新卡
            {
                path: "set/biandcard",
                name: "set-biandcard",
                component: setBindCard,
                meta: {
                    requiresAuth: true,
                    title: "绑定新卡",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 充值卡 使用记录
            {
                path: "set/cardrecord",
                name: "set-cardrecord",
                component: setCardRecord,
                meta: {
                    requiresAuth: true,
                    title: "使用记录",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 绑定手机号
            {
                path: "set/bindPhone",
                name: "set-bindPhone",
                component: bindPhone,
                meta: {
                    requiresAuth: true,
                    title: "绑定手机号",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 昵称
            {
                path: "set/nickname",
                name: "set-nickname",
                component: setNickname,
                meta: {
                    requiresAuth: true,
                    title: "修改昵称",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 手机号
            {
                path: "set/phone",
                name: "set-phone",
                component: setPhone,
                meta: {
                    requiresAuth: true,
                    title: "更换手机号",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 设置 帮助中心
            {
                path: "set/help",
                name: "set-help",
                component: setHelp,
                meta: {
                    requiresAuth: true,
                    title: "帮助中心",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 供应商中心
            {
                path: "btob/index",
                name: "btob-index",
                component: btobIndex,
                meta: {
                    requiresAuth: true,
                    title: "供应商中心",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 供应商中心
            {
                path: "btob/center",
                name: "btob-center",
                component: btobCenter,
                meta: {
                    requiresAuth: true,
                    title: "供应商账户",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 店铺设置
            {
                path: "shop/set",
                name: "shop-set",
                component: shopSet,
                meta: {
                    requiresAuth: true,
                    title: "店铺设置",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 店铺设置
            {
                path: "kuaidi/set",
                name: "kuaidi-set",
                component: kuaidiSet,
                meta: {
                    requiresAuth: true,
                    title: "快递设置",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 意见反馈
            {
                path: "set/feedback",
                name: "set-feedback",
                component: setFeedback,
                meta: {
                    requiresAuth: true,
                    title: "意见反馈",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 永久注销账号
            {
                path: "set/zhuxiao",
                name: "set-zhuxiao",
                component: setZhuxiao,
                meta: {
                    requiresAuth: true,
                    title: "永久注销账号",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 永久注销账号2
            {
                path: "set/zhuxiao2",
                name: "set-zhuxiao2",
                component: setZhuxiao2,
                meta: {
                    requiresAuth: true,
                    title: "永久注销账号",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 单页
            {
                path: "single/page",
                name: "single-page",
                component: singlePage,
                meta: {
                    requiresAuth: false,
                    title: "单页",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 匠人的代理商
            {
                path: "tradesman/partner",
                name: "tradesman-partner",
                component: tradesmanPartner,
                meta: {
                    requiresAuth: true,
                    title: "我的分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 直播
            {
                path: "zhibo/index",
                name: "zhibo-index",
                component: zhiboIndex,
                meta: {
                    requiresAuth: false,
                    title: "直播",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 直播 详情
            {
                path: "zhibo/detail",
                name: "zhibo-detail",
                component: zhiboDetail,
                meta: {
                    requiresAuth: false,
                    title: "直播",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 直播 申请
            {
                path: "zhibo/apply",
                name: "zhibo-apply",
                component: zhiboApply,
                meta: {
                    requiresAuth: true,
                    title: "直播申请",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 直播 申请中
            {
                path: "zhibo/applying",
                name: "zhibo-applying",
                component: zhiboApplying,
                meta: {
                    requiresAuth: true,
                    title: "直播申请审核",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 视频列表
            {
                path: "video/list/:type",
                name: "video-list",
                component: videoList,
                meta: {
                    requiresAuth: false,
                    title: "视频",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 视频详情
            {
                path: "video/detail",
                name: "video-detail",
                component: videoDetail,
                meta: {
                    requiresAuth: false,
                    title: "视频",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 视频详情
            {
                path: "video/play",
                name: "video-play",
                component: videoPlay,
                meta: {
                    requiresAuth: false,
                    title: "视频",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 直播视频回放详情
            {
                path: "posvideo/detail",
                name: "posvideo-detail",
                component: posvideoDetail,
                meta: {
                    requiresAuth: false,
                    title: "视频回放",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 直播视频详情播放
            {
                path: "posvideo/play",
                name: "posvideo-play",
                component: posvideoPlay,
                meta: {
                    requiresAuth: false,
                    title: "直播视频回放",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 供应商 详情
            {
                path: "seller/detail",
                name: "seller-detail",
                component: sellerDetail,
                meta: {
                    requiresAuth: false,
                    title: "供应商详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 供应商 收入
            {
                path: "seller/income",
                name: "seller-income",
                component: sellerIncome,
                meta: {
                    requiresAuth: true,
                    title: "供应商收入",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 供应商 商品
            {
                path: "seller/goods",
                name: "seller-goods",
                component: sellerGoods,
                meta: {
                    requiresAuth: true,
                    title: "供应商商品",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 供应商 店铺设置
            {
                path: "seller/shopset",
                name: "seller-shopset",
                component: sellerShop,
                meta: {
                    requiresAuth: true,
                    title: "供应商店铺设置",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区积分
            {
                path: "park/index",
                name: "park-index",
                component: parkIndex,
                meta: {
                    requiresAuth: true,
                    title: "园区积分",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 园区积分记录
            {
                path: "park/jifen",
                name: "park-jifen",
                component: parkJifen,
                meta: {
                    requiresAuth: true,
                    title: "积分列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 园区等级规则
            {
                path: "park/rank",
                name: "park-rank",
                component: parkRank,
                meta: {
                    requiresAuth: true,
                    title: "等级规则",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 头条 首页
            {
                path: "toutiao/index",
                name: "toutiao-index",
                component: toutiaoIndex,
                meta: {
                    requiresAuth: false,
                    title: "头条",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 头条 详情
            {
                path: "toutiao/detail",
                name: "toutiao-detail",
                component: toutiaoDetail,
                meta: {
                    requiresAuth: false,
                    title: "头条详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 头条 发布
            {
                path: "toutiao/publish",
                name: "toutiao-publish",
                component: toutiaoPublish,
                meta: {
                    requiresAuth: true,
                    title: "发布头条",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 定制 首页
            {
                path: "dingzhi/index",
                name: "dingzhi-index",
                component: dingzhiIndex,
                meta: {
                    requiresAuth: false,
                    title: "定制",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    app_icon_back: true,
                    share_config: true,
                },
            },
            // 定制 详情
            {
                path: "dingzhi/detail",
                name: "dingzhi-detail",
                component: dingzhiDetail,
                meta: {
                    requiresAuth: false,
                    title: "定制详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 定制 结算
            {
                path: "dingzhi/settle",
                name: "dingzhi-settle",
                component: dingzhiSettle,
                meta: {
                    requiresAuth: true,
                    title: "定制结算",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 订单列表
            {
                path: "order/dingzhi/index",
                name: "order-dingzhi-index",
                component: orderDingzhiIndex,
                meta: {
                    requiresAuth: true,
                    title: "定制订单",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 订单详情
            {
                path: "order/dingzhi/detail",
                name: "order-dingzhi-detail",
                component: orderDingzhiDetail,
                meta: {
                    requiresAuth: true,
                    title: "定制订单",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
			// 定制 订单快照
            {
                path: "order/dingzhi/kuaizhao",
                name: "order-dingzhi-kuaizhao",
                component: orderDingzhiKuaizhao,
                meta: {
                    requiresAuth: true,
                    title: "订单快照",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 社区
            {
                path: "dingzhi/shequ",
                name: "dingzhi-shequ",
                component: dingzhiSheQu,
                meta: {
                    requiresAuth: false,
                    title: "发布定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 我要定制,用于聊天时,发送定制表单
            {
                path: "dingzhi/form",
                name: "dingzhi-form",
                component: dingzhiForm,
                meta: {
                    requiresAuth: false,
                    title: "我要定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 我要定制,用于聊天时,发送定制表单
            {
                path: "dingzhi/formDetail",
                name: "dingzhi-formDetail",
                component: dingzhiFormDetail,
                meta: {
                    requiresAuth: false,
                    title: "我要定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 匠人列表
            {
                path: "dingzhi/tradesman",
                name: "dingzhi-tradesman",
                component: dingzhiTradesman,
                meta: {
                    requiresAuth: false,
                    title: "定制匠人",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 定制 匠人作品
            {
                path: "dingzhi/tradesman/works",
                name: "dingzhi-tradesman-works",
                component: dingzhiTradesmanWorks,
                meta: {
                    requiresAuth: false,
                    title: "作品展",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制详情 用户发布的
            {
                path: "dingzhi/detail/user",
                name: "dingzhi-detail-user",
                component: dingzhiDetailUser,
                meta: {
                    requiresAuth: false,
                    title: "定制详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 定制 发布
            {
                path: "dingzhi/publish",
                name: "dingzhi-publish",
                component: dingzhiPublish,
                meta: {
                    requiresAuth: false,
                    title: "发布",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 招标中
            {
                path: "order/dingzhi/bid",
                name: "order-dingzhi-bid",
                component: orderDingzhiBid,
                meta: {
                    requiresAuth: true,
                    title: "我的定制",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 我的定制
            {
                path: "my/dingzhi/index",
                name: "my-dingzhi-index",
                component: myDingzhiIndex,
                meta: {
                    requiresAuth: true,
                    title: "我的定制",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制 订单评价
            {
                path: "dingzhi/comment",
                name: "dingzhi-comment",
                component: dingzhiComment,
                meta: {
                    requiresAuth: true,
                    title: "定制评价",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 头条 社区
            {
                path: "toutiao/shequ",
                name: "toutiao-shequ",
                component: toutiaoSheQu,
                meta: {
                    requiresAuth: false,
                    title: "我的圈子",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 历史记忆 首页
            {
                path: "tohistory/index",
                name: "tohistory-index",
                component: tohistoryIndex,
                meta: {
                    requiresAuth: false,
                    title: "历史记忆",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 历史记忆 详情
            {
                path: "tohistory/detail",
                name: "tohistory-detail",
                component: tohistoryDetail,
                meta: {
                    requiresAuth: false,
                    title: "历史记忆",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 历史记忆 漂流列表
            {
                path: "adrift/list",
                name: "adrift-list",
                component: adriftList,
                meta: {
                    requiresAuth: false,
                    title: "书写记忆让爱漂流",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 历史记忆 漂流详情
            {
                path: "adrift/detail",
                name: "adrift-detail",
                component: adriftDetail,
                meta: {
                    requiresAuth: false,
                    title: "书写记忆让爱漂流",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: false,
                },
            },
            // 历史记忆 发布漂流
            {
                path: "adrift/publish",
                name: "adrift-publish",
                component: adriftPublish,
                meta: {
                    requiresAuth: true,
                    title: "书写记忆让爱漂流",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 我的漂流
            {
                path: "my/adrift/index",
                name: "my-adrift-index",
                component: myAdriftIndex,
                meta: {
                    requiresAuth: true,
                    title: "书写记忆让爱漂流",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 一级下的二级分销商
            {
                path: "my/second/agent",
                name: "my-second-agent",
                component: mySecondAgent,
                meta: {
                    requiresAuth: true,
                    title: "我的二级分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 视频购买 与约看支付整合在一块了,弃用
            {
                path: "video/pay",
                name: "video-pay",
                component: videoPay,
                meta: {
                    requiresAuth: true,
                    title: "支付",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 定制表单 匠人主动发给用户填写的
            {
                path: "dingzhi/form/touser",
                name: "dingzhi-form-touser",
                component: tradesmanToUserForm,
                meta: {
                    requiresAuth: true,
                    title: "定制单",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 匠人定制订单列表,他自己发出的
            {
                path: "tradesman/dingzhi/order",
                name: "tradesman-dingzhi-order",
                component: TradesmanDingzhiOrder,
                meta: {
                    requiresAuth: true,
                    title: "定制订单",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 匠人定制订单详情,他自己发出的
            {
                path: "tradesman/dingzhi/order/detail",
                name: "tradesman-dingzhi-order-detail",
                component: TradesmanDingzhiOrderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 视频评论
            {
                path: "video/comment",
                name: "video-comment",
                component: videoComment,
                meta: {
                    requiresAuth: true,
                    title: "发表评论",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区中心
            {
                path: "my/park/index",
                name: "my-park-index",
                component: myParkIndex,
                meta: {
                    requiresAuth: true,
                    title: "园区",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区提现
            {
                path: "my/park/withdraw",
                name: "my-park-withdraw",
                component: myParkWithdraw,
                meta: {
                    requiresAuth: true,
                    title: "提现",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区收入列表
            {
                path: "my/park/income",
                name: "my-park-income",
                component: myParkIncome,
                meta: {
                    requiresAuth: true,
                    title: "收入明细",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区订单
            {
                path: "my/park/order",
                name: "my-park-order",
                component: myParkOrder,
                meta: {
                    requiresAuth: true,
                    title: "订单列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区订单详情
            {
                path: "my/park/order/detail",
                name: "my-park-order-detail",
                component: myParkOrderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区匠人
            {
                path: "my/park/tradesman",
                name: "my-park-tradesman",
                component: myParkTradesmanList,
                meta: {
                    requiresAuth: true,
                    title: "匠人列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区分销商 一级
            {
                path: "my/park/agent",
                name: "my-park-agent",
                component: myParkAgent,
                meta: {
                    requiresAuth: true,
                    title: "一级分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 园区分销商 二级
            {
                path: "my/park/secagent",
                name: "my-park-secagent",
                component: myParkSecAgent,
                meta: {
                    requiresAuth: true,
                    title: "二级分销商",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 商城 区块链
            {
                path: "chain/index",
                name: "chain-index",
                component: chainIndex,
                meta: {
                    requiresAuth: false,
                    title: "区块链商城",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: false,
                },
			},
			// 商城 区块链 追溯码
			{
                path: "chain/tracecode",
                name: "chain-tracecode",
                component: chainTraceCode,
                meta: {
                    requiresAuth: false,
                    title: "追溯码查询",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 商城 区块链 扫码
			{
                path: "chain/scancode",
                name: "chain-scancode",
                component: chainScanCode,
                meta: {
                    requiresAuth: false,
                    title: "追溯码查询",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 商城 区块链 扫码
			{
                path: "chain/scancodedetail",
                name: "chain-scancodedetail",
                component: chainScanCodeDetail,
                meta: {
                    requiresAuth: false,
                    title: "追溯码查询",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 商城 区块链 扫码记录
			{
                path: "chain/scancoderecord",
                name: "chain-scancoderecord",
				component: chainScanCodeRecord,
				meta: {
                    requiresAuth: false,
                    title: "追溯码查询",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
			},
            // 我的视频观看记录
            {
                path: "video/log",
                name: "video-log",
                component: videoLog,
                meta: {
                    requiresAuth: true,
                    title: "观看记录",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
			// 智慧园区 首页
            {
                path: "smart/park",
                name: "smart-park",
                component: smartParkIndex,
                meta: {
                    requiresAuth: false,
                    title: "智慧园区",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
			// 智慧园区 参观馆
			{
                path: "smart/park/shoplist",
                name: "smart-park-shoplist",
                component: smartParkShopList,
                meta: {
                    requiresAuth: false,
                    title: "参观馆",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 预约馆
			{
                path: "smart/park/appoint",
                name: "smart-park-appoint",
                component: smartParkAppoint,
                meta: {
                    requiresAuth: false,
                    title: "预约入口",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 预约票
			{
                path: "smart/park/appointticket",
                name: "smart-park-appoint",
                component: smartParkAppointTicket,
                meta: {
                    requiresAuth: true,
                    title: "门票预订",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 团体票表单
			{
                path: "smart/park/tuanti",
                name: "smart-park-tuanti",
                component: smartParkTuanti,
                meta: {
                    requiresAuth: true,
                    title: "预约",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 添加参观者表单
			{
                path: "smart/park/addvisitor",
                name: "smart-park-addvisitor",
                component: smartParkAddvisitor,
                meta: {
                    requiresAuth: true,
                    title: "添加参观者",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 个人票表单
			{
                path: "smart/park/personal",
                name: "smart-park-personal",
                component: smartParkPersonal,
                meta: {
                    requiresAuth: true,
                    title: "预约",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 核销页
			{
                path: "smart/park/hexiao",
                name: "smart-park-hexiao",
                component: smartParkHexiao,
                meta: {
                    requiresAuth: true,
                    title: "核销",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 参观者列表
			{
                path: "visitor/list",
                name: "visitor-list",
                component: visitorList,
                meta: {
                    requiresAuth: true,
                    title: "参观者列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 支付
			{
                path: "smartpark/pay",
                name: "smartpark-pay",
                component: smartparkPay,
                meta: {
                    requiresAuth: true,
                    title: "支付",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 支付成功
			{
                path: "smartpark/paysuccess",
                name: "smartpark-paysuccess",
                component: smartparkPaysuccess,
                meta: {
                    requiresAuth: true,
                    title: "支付成功",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 订单列表
			{
                path: "smartpark/order",
                name: "smartpark-order",
                component: smartParkOrderList,
                meta: {
                    requiresAuth: true,
                    title: "订单列表",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
			// 智慧园区 订单详情
			{
                path: "smartpark/order/detail",
                name: "smartpark-order-detail",
                component: smartParkOrderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 智慧园区 订单申请发票
			{
                path: "smartpark/order/apply",
                name: "smartpark-order-apply",
                component: smartParkOrderApply,
                meta: {
                    requiresAuth: true,
                    title: "申请发票",
                    role: 0,
                    keepAlive: true,
                    icon_back: false,
                    share_config: true,
                },
            },
			// 智慧园区 次卡列表
			{
                path: "smartpark/card/list",
                name: "smartpark-card-list",
                component: smartParkCardList,
                meta: {
                    requiresAuth: true,
                    title: "次卡列表",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
			// 智慧园区 用户的次卡列表
			{
                path: "my/smartpark/card",
                name: "my-smartpark-card",
                component: mySmartparkCard,
                meta: {
                    requiresAuth: true,
                    title: "我的次卡",
                    role: 0,
                    keepAlive: true,
                    icon_back: true,
                    share_config: true,
                },
            },
            {
                path: "my/smartpark/carddetail",
                name: "my-smartpark-carddetail",
                component: mySmartparkCardDetail,
                meta: {
                    requiresAuth: true,
                    title: "我的次卡详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                    share_config: true,
                },
            },
            // 原来的支付 20201030
            {
                path: "reapal/index", //https://mall.shidaijiyi.com/reapal/index
                name: "reapal-index",
                component: reapalIndex,
                meta: {
                    requiresAuth: true,
                    title: "支付",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 公共的支付
            {
                path: "pay/index",
                name: "pay-index",
                component: payIndex,
                meta: {
                    requiresAuth: true,
                    title: "支付",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
            },
            // 获取位置
            {
                path: "location/list",
                name: "location-list",
                component: locationList,
                meta: {
                    requiresAuth: false,
                    title: "获取位置",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: false,
                },
			},
			// 园区商城列表页(多个园区)
			{
				path: "parkmall/list",
				name: "parkmall-list",
				component: parkmallList,
				meta: {
				  requiresAuth: false,
				  title: "园区商城",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: true
				},
			},
			// 园区商城首页
			{
				path: "parkmall/index",
				name: "parkmall-index",
				component: parkmallIndex,
				meta: {
				  requiresAuth: false,
				  title: "园区商城",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: true
				},
			},
			// 园区商城商品列表
			{
				path: "parkmall/goods/list",
				name: "parkmall-goods-list",
				component: parkmallGoodsList,
				meta: {
				  requiresAuth: false,
				  title: "商品列表",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: true,
				},
			},
			// 献礼 首页
			{
				path: "xianli/index",
				name: "xianli-index",
				component: xianliIndex,
				meta: {
				  requiresAuth: false,
				  title: "时代记忆",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: false,
				},
			},
			// 献礼 发布
			{
				path: "xianli/publish",
				name: "xianli-publish",
				component: xianliPublish,
				meta: {
				  requiresAuth: true,
				  title: "发起献礼",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: true,
				},
			},
			// 献礼 详情
			{
				path: "xianli/detail",
				name: "xianli-detail",
				component: xianliDetail,
				meta: {
				  requiresAuth: false,
				  title: "献礼详情",
				  role: 0,
				  keepAlive: false,
				  icon_back: false,
				  share_config: false,
				},
			},
			// 足迹
			{
				path: "my/zuji",
				name: "my-zuji",
				component: zujiIndex,
				meta: {
				  requiresAuth: true,
				  title: "足迹",
				  role: 0,
				  keepAlive: true,
				  icon_back: true,
				  share_config: false,
				},
			},
            // uuid 跳转商品详情
            {
                path: "good/:uuid",
                name: "uuid-index",
                component: uuidIndex,
                meta: {
                    requiresAuth: false,
                    title: "商品详情",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                },
            },
			// 设置 定制专属价
			{
                path: "tradesman/dingzhi/price",
                name: "tradesman-dingzhi-price",
                component: dingzhiZhuanshujia,
                meta: {
                    requiresAuth: true,
                    title: "专属价",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                },
            },
			// 约看订单详情 
			{
                path: "yuekan/order/detail",
                name: "yuekan-order-detail",
                component: yuankanOrderDetail,
                meta: {
                    requiresAuth: true,
                    title: "订单详情 ",
                    role: 0,
                    keepAlive: false,
                    icon_back: true,
                },
            },
            // 开发中
            {
                path: "system/develop",
                name: "system-develop",
                component: developing,
                meta: {
                    requiresAuth: false,
                    title: "系统开发中",
                    role: 0,
                    keepAlive: false,
                    icon_back: false,
                    share_config: true,
                },
            },
            // 其它404
            {
                path: "*",
                name: "noaccess",
                component: Nofound,
                meta: {
                    requiresAuth: true,
                    pageTitle: "404",
                },
            },
        ],
    },
];
